module.exports = __webpack_public_path__ + "media/images/games/35gender/legos-96018d89eb9ef8db77555bf79f4b580d.png";